module.exports = __webpack_public_path__ + "img/inplant1new.b80bc3d0.jpg";